import React from 'react';
import {asyncComponent} from 'react-async-component';

export const AsyncTrustpilot = asyncComponent({
    resolve: () => import(
        /* webpackChunkName: "trustpilot" */
        /* webpackPreload: true */
        './Trustpilot'
    ),
    LoadingComponent: () => <span />,
    serverMode: 'defer'
});
